<template>
  <div class="event-view mx-auto">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Event',
  metaInfo () {
    return {
      title: '活動'
    }
  },
  data () {
    return {
    }
  },
  components: {
  },
  computed: {
  },
  mounted () {
  },
  updated () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
